import { Component } from 'shimmer'

import { MeshPhongMaterial, Color, DoubleSide } from 'three'

import { Loader } from '@/utils/Loader'

export class Room extends Component {
  constructor ({ url }) {
    super({ name: 'Room' })

    this.destroy = this.destroy.bind(this)

    this.promise = new Promise(resolve => {
      this.resolve = resolve
    })

    this.promises = []

    this.url = url

    this.promises.push(Loader.load(this.url).then(object => {
      this.object = object
      this.add(this.object)
    }))

    // this.scale.set(.2, .2, .2)
    this.rotation.y = -Math.PI * .5

    Promise.all(this.promises).then(this.resolve)
  }

  onDestroy () {
    this.traverse((child) => {
      if (child.isMesh) {
        child.material.dispose()
        child.geometry.dispose()
      }
    })
    this.destroy()
  }
}